(function () {
  'use strict';

  if (window.__sizeWarningModalLoaded) return;
  window.__sizeWarningModalLoaded = true;

  var MARKER_ATTR = 'data-size-check-passed';

  function routes() {
    var r = (window.FoxTheme && window.FoxTheme.routes) || {};
    return {
      cart: r.cart_url || '/cart.js',
      add: r.cart_add_url || '/cart/add.js',
      change: r.cart_change_url || '/cart/change.js',
    };
  }

  function t(key, fallback) {
    var strings = (window.FoxTheme && window.FoxTheme.sizeWarningStrings) || {};
    return strings[key] || fallback || '';
  }

  function getProductData(form) {
    var script = form.querySelector('script[data-size-warning-product-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.warn('[size-warning] Invalid product data JSON', e);
      return null;
    }
  }

  function fetchCart() {
    return fetch(routes().cart, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  // Option names that describe sizing. The storefront JSON is localized, so
  // match both the EN originals (Size, Pants Length) and the DE translations
  // (Größe, Hosenlänge).
  function isSizeDimension(name) {
    var n = String(name || '').toLowerCase();
    return (
      n.indexOf('size') !== -1 ||
      n.indexOf('größe') !== -1 ||
      n.indexOf('grösse') !== -1 ||
      n.indexOf('groesse') !== -1 ||
      n.indexOf('length') !== -1 ||
      n.indexOf('länge') !== -1 ||
      n.indexOf('laenge') !== -1
    );
  }

  // A cart item only counts as a size conflict when both variants exist in the
  // product data and differ in size/length dimensions alone. A different color
  // (or any other non-size option, e.g. gift card amount) is a deliberate
  // second purchase — no modal.
  function isSizeOnlyConflict(data, existingVariantId, newVariantId) {
    var variants = (data && data.variants) || [];
    var existing = null;
    var next = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (String(v.id) === String(existingVariantId)) existing = v;
      if (String(v.id) === String(newVariantId)) next = v;
    }
    if (!existing || !next || !Array.isArray(existing.options) || !Array.isArray(next.options)) return false;
    var names = (data && data.option_names) || [];
    var sizeDiff = false;
    var len = Math.max(existing.options.length, next.options.length);
    for (var j = 0; j < len; j++) {
      if (existing.options[j] === next.options[j]) continue;
      if (isSizeDimension(names[j])) {
        sizeDiff = true;
      } else {
        return false;
      }
    }
    return sizeDiff;
  }

  function findDuplicate(cart, data, newVariantId) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var pidStr = String(data && data.product_id);
    var vidStr = String(newVariantId);
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (
        String(item.product_id) === pidStr &&
        String(item.variant_id) !== vidStr &&
        isSizeOnlyConflict(data, item.variant_id, newVariantId)
      ) {
        return item;
      }
    }
    return null;
  }

  function getSectionsToBundle() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    // Dedupe
    var seen = {};
    return sections.filter(function (s) {
      if (seen[s]) return false;
      seen[s] = true;
      return !!s;
    });
  }

  function publishCartUpdate(cartJson) {
    try {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.publish && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      }
    } catch (e) { /* noop */ }
  }

  function showCartDrawer(triggerEl) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show(triggerEl || document.body);
    }
  }

  function cartChange(idOrKey, quantity, sectionsList) {
    var body = JSON.stringify({
      id: idOrKey,
      quantity: quantity,
      sections: (sectionsList || []).join(','),
      sections_url: window.location.pathname,
    });
    return fetch(routes().change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: body,
    }).then(function (r) { return r.json(); });
  }

  function cartAdd(variantId, quantity, sectionsList) {
    var body = JSON.stringify({
      items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }],
      sections: (sectionsList || []).join(','),
      sections_url: window.location.pathname,
    });
    return fetch(routes().add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: body,
    }).then(function (r) { return r.json(); });
  }

  // After all cart operations, fetch the full cart and merge sections from the
  // last response, then publish the cartUpdate so the drawer re-renders.
  // openDrawer=false: callers that deliberately do NOT open the cart drawer
  // (Shop the Look cards) get a plain `cart:refresh` instead.
  function refreshCartAndNotify(triggerEl, lastResponseWithSections, openDrawer) {
    return fetch(routes().cart, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cartJson) {
        if (lastResponseWithSections && lastResponseWithSections.sections) {
          cartJson.sections = lastResponseWithSections.sections;
        }
        publishCartUpdate(cartJson);
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: cartJson } }));
        if (openDrawer === false) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } else {
          showCartDrawer(triggerEl);
        }
        return cartJson;
      });
  }

  // -------------------- Modal --------------------
  var modal = null;
  var modalState = {
    form: null,
    submitter: null,
    productData: null,
    existingItem: null,
    newVariantId: null,
    selectedVariantId: null,
    quantity: 1,
    openDrawer: true,
    onDone: null,
  };

  function ensureModal() {
    if (modal) return modal;
    modal = document.querySelector('[data-size-warning-modal]');
    if (!modal) return null;

    modal.querySelectorAll('[data-size-warning-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });
    modal.querySelector('[data-size-warning-confirm]').addEventListener('click', onConfirm);
    modal.querySelector('[data-size-warning-both]').addEventListener('click', onAddBoth);
    return modal;
  }

  function setActiveChoice(variantId) {
    modalState.selectedVariantId = variantId;
    var confirmBtn = modal.querySelector('[data-size-warning-confirm]');
    confirmBtn.disabled = !variantId;
    var variant = variantId
      ? modalState.productData.variants.find(function (v) { return String(v.id) === String(variantId); })
      : null;
    if (variant) {
      confirmBtn.textContent = t('cta_confirm_with_size', 'Continue with {{ size }}').replace('{{ size }}', variant.title);
    } else {
      confirmBtn.textContent = t('cta_confirm', 'Continue');
    }
  }

  function renderChoices() {
    var choicesEl = modal.querySelector('[data-size-warning-choices]');
    var data = modalState.productData;
    var existing = modalState.existingItem;
    var newId = String(modalState.newVariantId);
    var existingId = String(existing.variant_id);

    Array.from(choicesEl.querySelectorAll('.size-warning-choice')).forEach(function (n) { n.remove(); });

    var ids = [existingId, newId];
    var seen = {};
    var choices = [];
    ids.forEach(function (id) {
      if (seen[id]) return;
      seen[id] = true;
      var v = data.variants.find(function (x) { return String(x.id) === id; });
      if (v) choices.push(v);
    });

    choices.forEach(function (variant) {
      var label = document.createElement('label');
      label.className = 'size-warning-choice';
      var vIdStr = String(variant.id);
      if (vIdStr === existingId) {
        label.setAttribute('data-in-cart', 'true');
      }
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'size-warning-choice';
      input.value = vIdStr;
      input.addEventListener('change', function () { setActiveChoice(vIdStr); });

      var labelText = document.createElement('span');
      labelText.className = 'size-warning-choice__label';
      labelText.textContent = variant.title;

      label.appendChild(input);
      label.appendChild(labelText);

      if (vIdStr === existingId) {
        var badge = document.createElement('span');
        badge.className = 'size-warning-choice__badge';
        badge.textContent = t('badge_in_cart', 'in cart');
        label.appendChild(badge);
      }
      choicesEl.appendChild(label);
    });

    // Preselect the NEW variant by default
    var newRadio = choicesEl.querySelector('input[value="' + newId + '"]');
    if (newRadio) {
      newRadio.checked = true;
      setActiveChoice(newId);
    } else {
      setActiveChoice(null);
    }
  }

  // Fit recommendation (custom.fit_recommendation_2) — one card per line, label/value split on ':'
  // Returns true when at least one card was rendered.
  function renderFitCards(data) {
    var fitWrap = modal.querySelector('[data-size-warning-fit-rec]');
    var fitRaw = data && data.fit_recommendation;
    if (fitRaw && String(fitRaw).trim() && fitWrap) {
      var normalized = String(fitRaw)
        .replace(/\r\n?/g, '\n')
        .replace(/<br\s*\/?>/gi, '\n');
      var lines = normalized.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
      fitWrap.innerHTML = '';
      lines.forEach(function (line) {
        var card = document.createElement('div');
        card.className = 'size-warning-modal__fit-card';
        var colonIdx = line.indexOf(':');
        if (colonIdx > 0) {
          var label = line.slice(0, colonIdx).trim();
          var value = line.slice(colonIdx + 1).trim();
          var labelEl = document.createElement('div');
          labelEl.className = 'size-warning-modal__fit-card-label';
          labelEl.textContent = label;
          var valueEl = document.createElement('div');
          valueEl.className = 'size-warning-modal__fit-card-value';
          valueEl.textContent = value;
          card.appendChild(labelEl);
          card.appendChild(valueEl);
        } else {
          var valueEl2 = document.createElement('div');
          valueEl2.className = 'size-warning-modal__fit-card-value';
          valueEl2.textContent = line;
          card.appendChild(valueEl2);
        }
        fitWrap.appendChild(card);
      });
      fitWrap.hidden = false;
      return true;
    }
    if (fitWrap) {
      fitWrap.innerHTML = '';
      fitWrap.hidden = true;
    }
    return false;
  }

  // Info mode: only the fit cards are shown (opened from the PDP fit note),
  // no size choices / CTAs. Inline display toggles on purpose — a `hidden`
  // attribute would lose against the class display rules.
  function setInfoMode(on) {
    var choicesEl = modal.querySelector('[data-size-warning-choices]');
    var actionsEl = modal.querySelector('.size-warning-modal__actions');
    if (choicesEl) choicesEl.style.display = on ? 'none' : '';
    if (actionsEl) actionsEl.style.display = on ? 'none' : '';
    modal.classList.toggle('size-warning-modal--info', on);
  }

  function showModal(focusEl) {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-warning-modal-open');
    if (focusEl) focusEl.focus();
  }

  function openModal(opts) {
    ensureModal();
    if (!modal) return;
    modalState = Object.assign({ selectedVariantId: null, quantity: 1, openDrawer: true, onDone: null }, opts);

    renderFitCards(modalState.productData);
    setInfoMode(false);
    renderChoices();
    showModal(modal.querySelector('[data-size-warning-confirm]'));
  }

  function openInfoModal(productData) {
    ensureModal();
    if (!modal) return;
    modalState = { form: null, submitter: null, productData: productData, existingItem: null, newVariantId: null, selectedVariantId: null, quantity: 1, openDrawer: true, onDone: null };

    if (!renderFitCards(productData)) return;
    setInfoMode(true);
    showModal(modal.querySelector('.size-warning-modal__close'));
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.body.classList.remove('size-warning-modal-open');
    // Re-enable buttons
    var bothBtn = modal.querySelector('[data-size-warning-both]');
    var confirmBtn = modal.querySelector('[data-size-warning-confirm]');
    if (bothBtn) { bothBtn.disabled = false; bothBtn.classList.remove('btn--loading'); }
    if (confirmBtn) { confirmBtn.classList.remove('btn--loading'); }
    // Re-enable submit button on original form
    if (modalState.form) {
      var btn = modalState.form.querySelector('[type="submit"]');
      if (btn) {
        btn.classList.remove('btn--loading');
        btn.removeAttribute('aria-disabled');
      }
    }
  }

  function onConfirm() {
    if (!modalState.selectedVariantId) return;
    var existing = modalState.existingItem;
    var selectedId = String(modalState.selectedVariantId);
    var existingId = String(existing.variant_id);
    var newId = String(modalState.newVariantId);
    var submitter = modalState.submitter || (modalState.form && modalState.form.querySelector('[type="submit"]'));
    var openDrawer = modalState.openDrawer;
    var onDone = modalState.onDone;

    var confirmBtn = modal.querySelector('[data-size-warning-confirm]');
    var bothBtn = modal.querySelector('[data-size-warning-both]');
    confirmBtn.disabled = true;
    confirmBtn.classList.add('btn--loading');
    if (bothBtn) bothBtn.disabled = true;

    var sectionsList = getSectionsToBundle();

    var action;
    if (selectedId === existingId) {
      // User wants the size that's already in cart — leave cart untouched
      action = Promise.resolve(null);
    } else if (selectedId === newId) {
      // User wants the new size, replace the existing one
      action = cartChange(existing.key, 0, sectionsList).then(function () {
        return cartAdd(selectedId, modalState.quantity || 1, sectionsList);
      });
    } else {
      // Edge case: selected variant is neither existing nor new — just add it
      action = cartAdd(selectedId, modalState.quantity || 1, sectionsList);
    }

    action
      .then(function (lastResponse) { return refreshCartAndNotify(submitter, lastResponse, openDrawer); })
      // Deliberate successful finish — also when the cart was left untouched
      // because the customer picked the size that is already in the cart.
      .then(function () { if (typeof onDone === 'function') onDone(); })
      .catch(function (err) { console.warn('[size-warning] confirm failed', err); })
      .finally(function () {
        confirmBtn.classList.remove('btn--loading');
        closeModal();
      });
  }

  function onAddBoth() {
    var submitter = modalState.submitter || (modalState.form && modalState.form.querySelector('[type="submit"]'));
    var openDrawer = modalState.openDrawer;
    var onDone = modalState.onDone;
    var bothBtn = modal.querySelector('[data-size-warning-both]');
    var confirmBtn = modal.querySelector('[data-size-warning-confirm]');
    bothBtn.disabled = true;
    bothBtn.classList.add('btn--loading');
    confirmBtn.disabled = true;

    var sectionsList = getSectionsToBundle();

    cartAdd(modalState.newVariantId, modalState.quantity || 1, sectionsList)
      .then(function (lastResponse) { return refreshCartAndNotify(submitter, lastResponse, openDrawer); })
      .then(function () { if (typeof onDone === 'function') onDone(); })
      .catch(function (err) { console.warn('[size-warning] add both failed', err); })
      .finally(function () {
        bothBtn.classList.remove('btn--loading');
        bothBtn.disabled = false;
        closeModal();
      });
  }

  // -------------------- Fit-note trigger (info mode) --------------------
  // The "Fits true to size" note on the PDP opens the same modal, info-only.
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var trigger = event.target.closest('[data-fit-rec-trigger]');
    if (!trigger) return;
    event.preventDefault();

    // Product data lives in the buy-buttons form of the same section
    // (main product or quick view); fall back to the first form on the page.
    var scope = trigger.closest('section') || document;
    var script =
      scope.querySelector('script[data-size-warning-product-data]') ||
      document.querySelector('script[data-size-warning-product-data]');
    if (!script) return;

    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      console.warn('[size-warning] Invalid product data JSON', e);
      return;
    }
    openInfoModal(data);
  });

  // -------------------- Submit interception --------------------
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[is="product-form"]')) return;
      if (form.getAttribute(MARKER_ATTR) === 'true') return;

      var data = getProductData(form);
      if (!data) return;

      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput || variantInput.disabled) return;
      var newVariantId = variantInput.value;
      if (!newVariantId) return;

      var qty = 1;
      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput && qtyInput.value) qty = parseInt(qtyInput.value, 10) || 1;

      event.preventDefault();
      event.stopImmediatePropagation();

      var submitter = event.submitter || form.querySelector('[type="submit"]');

      fetchCart()
        .then(function (cart) {
          var existing = findDuplicate(cart, data, newVariantId);
          if (!existing) {
            form.setAttribute(MARKER_ATTR, 'true');
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit(submitter);
            } else {
              form.submit();
            }
            setTimeout(function () { form.removeAttribute(MARKER_ATTR); }, 50);
            return;
          }
          openModal({
            form: form,
            submitter: submitter,
            productData: data,
            existingItem: existing,
            newVariantId: newVariantId,
            quantity: qty,
          });
        })
        .catch(function (err) {
          console.warn('[size-warning] fetch failed, falling back', err);
          form.setAttribute(MARKER_ATTR, 'true');
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(submitter);
          } else {
            form.submit();
          }
          setTimeout(function () { form.removeAttribute(MARKER_ATTR); }, 50);
        });
    },
    true // capture
  );

  // -------------------- Public API --------------------
  // For buy buttons that are NOT a product form (Shop the Look cards, …).
  // Same fallback philosophy as the submit interceptor: on any error we
  // report "not handled" so the caller just adds to cart normally.
  window.TOSSizeWarning = {
    // Returns Promise<boolean>: true = modal took over, caller must NOT add.
    check: function (opts) {
      opts = opts || {};
      try {
        if (!ensureModal()) return Promise.resolve(false);
      } catch (e) {
        return Promise.resolve(false);
      }
      return fetchCart()
        .then(function (cart) {
          var existing = findDuplicate(cart, opts.productData, opts.variantId);
          if (!existing) return false;
          openModal({
            form: null,
            submitter: opts.trigger || null,
            productData: opts.productData,
            existingItem: existing,
            newVariantId: opts.variantId,
            quantity: opts.quantity || 1,
            openDrawer: opts.openDrawer !== false,
            onDone: opts.onDone || null,
          });
          return true;
        })
        .catch(function (err) {
          console.warn('[size-warning] check failed, falling back', err);
          return false;
        });
    },
  };
})();
